import { SearchBar } from '@/components/Common';
import { Header } from '@/components/Layout/Header/Header';
import { TopicsList } from '@/components/Views';
import AddNewFaq from './AddNewFaq';
import FaqFilter from './FaqFilter';
import { FaqForm } from './FaqForm';
import { FaqList } from './FaqList';
import { useFaqList } from './FaqList.hook';

export const Faq = () => {
  const { selectedFaq, setSelectedFaq, setIsOpenModal, faqCategories } =
    useFaqList();
  
  return (
    <div className="flex flex-col max-h-screen">
      <Header title="FAQ" userName="Mas Aly" role="Admin" />
      <div className="grid grid-cols-[25%_auto] items-start">
        <div className="pt-5 flex flex-col gap-10 h-[calc(100vh_-_110px)] overflow-hidden">
          <SearchBar placeholder="Mot clé" />
          <TopicsList
            showBtn={true}
            items={faqCategories ?? []}
            onItemClick={(item) => setSelectedFaq(item)}
            selectedItemId={selectedFaq?._id}
            btnTitle="Ajouter une catégorie"
            onAddClick={() => setIsOpenModal(true)}
          />
        </div>
        <div className="flex flex-col gap-2 pl-10 pr-4 pt-3 h-[calc(100vh_-_110px)] overflow-hidden">
          <FaqFilter />
          <FaqList />
          <AddNewFaq />
          <FaqForm />
        </div>
      </div>
    </div>
  );
};
